<template>
  <v-card tile :link="url != null" :to="url">

    <v-card-title
      v-if="$slots.title != null || title != null"
      v-bind:class="['pa-2', {
        'lighten-3 py-0': !!$slots.subtitle,
        'grey': changeColor() && !!$slots.subtitle
      }]"
      v-bind:style="{ fontSize: '1.10rem' }"
    >
      <v-btn
        v-if="!!$slots.subtitle"
        icon
        small
        @click.prevent="show = !show"
      >
        <v-icon v-if="show">mdi-chevron-up</v-icon>
        <v-icon v-else>mdi-chevron-down</v-icon>
      </v-btn>
      <slot name="title">
        <span>{{ title || "" }}</span>
      </slot>
    </v-card-title>

    <v-expand-transition v-if="$slots.subtitle != null || subtitle != null">
      <div v-show="show">
        <v-card-text class="subtitle py-2">
          <slot name="subtitle" v-if="!!$slots.subtitle"></slot>
          <span v-else>{{ subtitle }}</span>
        </v-card-text>
      </div>
    </v-expand-transition>

    <v-card-text v-if="$slots.footer != null || footer != null" class="py-2">
      <slot name="footer" v-if="!!$slots.footer"></slot>
      <span v-else>{{ footer || "" }}</span>
      <v-expand-transition v-if="$slots.menuAction">
        <slot name="menuAction"></slot>
      </v-expand-transition>
    </v-card-text>

    <v-card-actions v-if="!!$slots.actions">
      <slot name="actions"></slot>
    </v-card-actions>

    <v-card-actions v-else-if="actions.length > 0">
      <v-btn
        v-for="(action, i) in actions"
        :key="`action-${i}`"
        outlined
        rounded
        text
        @click="$emit(`action_${action.method}`)"
      >
      {{ action.title }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<!--
  LIST ITEM DESIGN CUSTOMIZATION

  Slots:
    - title: slot to customize the card title
    - subtitle: slot to customize the card subtitle
    - footer: slot to customize the card footer
    - buttons: slot to customize the card actions
-->
<script>
export default {
  props: {
    title: String,
    subtitle: String,
    footer: String,
    actions: { // click -> $emit(`click.action_${actionname}`)
      type: Array,
      default: () => ([]),
    },
    showOpen: Boolean,
    url: String,
  },
  data() {
    return {
      show: this.showOpen || false,
    };
  },
  methods: {
    changeColor() {
      let result = true;
      if ((window.location.pathname).includes('requests')
       || (window.location.pathname).includes('pending')
       || (window.location.pathname).includes('search')
       || (window.location.pathname).includes('approvals')
       || (window.location.pathname).includes('incidenciasproactivas')) {
        result = false;
      }
      return result;
    },
  },
};
</script>
